import type { Locale } from 'date-fns';
import broadcastNotification from 'src/common/components/Notification/broadcastNotification';
import { formatDateForDisplay } from 'src/common/utils/dateHelpers';
import { SnoozeFormState } from 'src/admin/common/components/SnoozeModal/types';

type ListingAction = 'unsnooze' | 'snooze' | 'publish-and-unsnooze';
const bulkSnoozeNotifications = (
  error: boolean,
  action: ListingAction,
  values?: SnoozeFormState,
  locale?: Locale,
): void => {
  if (values && !error) {
    const sameDates = values?.snooze_start_date === values?.snooze_end_date;
    const snoozeEnabled = values?.snooze_enabled;
    broadcastNotification({
      variant: 'info',
      translation: 'admin-listings',
      i18nKey: `listing-editor-bulk-notifications--${action}-title`,
      i18nMessageKey: sameDates && snoozeEnabled
        ? `listing-editor-bulk-notifications--${action}-same-dates`
        : `listing-editor-bulk-notifications--${action}`,
      i18nMessageKeyCount: values?.boats?.length || 1,
      translationOption: {
        count: values?.boats?.length || 1,
        startDate: formatDateForDisplay(values.snooze_start_date, true, locale),
        endDate: formatDateForDisplay(values.snooze_end_date, true, locale),
      },
    });
  } else {
    broadcastNotification({
      variant: error ? 'error' : 'info',
      translation: 'admin-listings',
      i18nKey: error
        ? `listing-editor-bulk-notifications--${action}-error`
        : `listing-editor-bulk-notifications--${action}`,
      translationOption: {
        count: values?.boats?.length || 1,
      },
    });
  }
};

export default bulkSnoozeNotifications;
